import { Theme, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { Container } from "@outschool/ui-legacy-component-library";
import { responsive } from "@outschool/ui-utils";
import React from "react";

import TabbedVideoPlayer, { TabConfig } from "../Video/TabbedVideoPlayer";

export enum OSInActionVariants {
  Parent,
  Teacher,
}

function OutschoolInAction(
  {
    trackTouch,
    variant = OSInActionVariants.Parent,
  }: { trackTouch: () => void; variant?: OSInActionVariants },
  ref: React.Ref<HTMLDivElement>,
) {
  const { t } = useTranslation(
    "ui-components-website\\HomePage\\OutschoolInAction",
  );

  const OUTSCHOOL_IN_ACTION_VARIANTS: {
    [variant in OSInActionVariants]: TabConfig[];
  } = {
    [OSInActionVariants.Parent]: [
      {
        title: t("Preview a class"),
        description: t(
          "Outschool teacher, Tammy, sparks creativity in the classroom during a live video class.",
        ),
        videoPlaybackID: "K4eLaA5oKbvXhdRS01IPH3W3pKiEI78T5",
        thumbnailUrl:
          "https://image.mux.com/K4eLaA5oKbvXhdRS01IPH3W3pKiEI78T5/thumbnail.png?time=9&height=318&width=566",
      },
      {
        title: t("Reignite their love of learning"),
        description: t(
          "Outschool has over 5,000 top-rated teachers with diverse backgrounds, experiences, and passions, so it’s easy to find classes your kid will connect with.",
        ),
        videoPlaybackID: "fzq7W8Om5O4y902O8z9tASXGy9HYSa01ba",
        thumbnailUrl:
          "https://image.mux.com/fzq7W8Om5O4y902O8z9tASXGy9HYSa01ba/thumbnail.jpg?time=0&height=318&width=566",
      },
      {
        title: t("Learn how Outschool works"),
        description: t(
          "Kids can learn on any device with live video classes that fit their interests and schedule.",
        ),
        videoPlaybackID: "iPWZ01J69A6HCR99IVXV3WYMJ1f00SDfmt",
        thumbnailUrl:
          "https://image.mux.com/iPWZ01J69A6HCR99IVXV3WYMJ1f00SDfmt/thumbnail.jpg?time=1&height=318&width=566",
      },
    ],
    [OSInActionVariants.Teacher]: [
      {
        title: t("Preview a Live Video Class"),
        description: t(
          "Outschool teacher, Tammy, sparks creativity in the classroom during a live video class.",
        ),
        videoPlaybackID: "K4eLaA5oKbvXhdRS01IPH3W3pKiEI78T5",
        thumbnailUrl:
          "https://image.mux.com/K4eLaA5oKbvXhdRS01IPH3W3pKiEI78T5/thumbnail.png?time=9&height=318&width=566",
      },
      {
        title: t("Meet an Outschool Teacher"),
        description: t("Learn how Outschool inspires Erin as a teacher."),
        videoPlaybackID: "DFiIbShwQPux018P4ZokMLi8ctarmoaiB",
        thumbnailUrl:
          "https://image.mux.com/DFiIbShwQPux018P4ZokMLi8ctarmoaiB/thumbnail.jpg?time=7&height=318&width=566",
      },
      {
        title: t("How Outschool Works"),
        description: t(
          "Teach anything you’re passionate about and let Outschool handle the logistics.",
        ),
        videoPlaybackID: "sHF5P6NT02mURPqjAWAEbOZIQY6mvIJIv",
        thumbnailUrl:
          "https://image.mux.com/sHF5P6NT02mURPqjAWAEbOZIQY6mvIJIv/thumbnail.jpg?time=4&height=318&width=566",
      },
    ],
  };
  const tabs = OUTSCHOOL_IN_ACTION_VARIANTS[variant];

  return (
    <Container
      ref={ref}
      sx={{
        paddingY: responsive({ default: "3em", medium: "6em" }),
        textAlign: "center",
      }}
    >
      <Typography
        variant="h2"
        sx={(theme: Theme) => ({
          marginBottom: "1em",

          [theme.breakpoints.up("md")]: {
            marginBottom: "2em",
          },
        })}
      >
        {t("Outschool in action")}
      </Typography>
      <TabbedVideoPlayer tabs={tabs} trackTouch={trackTouch} />
    </Container>
  );
}

export default React.forwardRef(OutschoolInAction);
